import api from '@/lib/axios';

import type { PaginatedResponse } from '@/types/tenant';
import type {
  CreateLegalEntityPayload,
  LegalEntityDto,
  LegalEntityListItem,
  UpdateLegalEntityPayload,
} from '@/types/legalEntity';
import type { ListFilterPayload } from '@/types/filters';

// ============================================
// Query Params
// ============================================

interface GetLegalEntitiesParams {
  page?: number;
  size?: number;
  sort?: string;
}

// ============================================
// Legal Entities CRUD
// ============================================

export const getLegalEntities = async (
  params: GetLegalEntitiesParams = {},
  body?: ListFilterPayload,
): Promise<PaginatedResponse<LegalEntityListItem>> => {
  const response = await api.post<PaginatedResponse<LegalEntityListItem>>(
    '/platform-service/v1/legal-entities/list',
    body ?? {},
    { params },
  );
  return response.data;
};

export const getLegalEntityById = async (id: string): Promise<LegalEntityDto> => {
  const response = await api.get<LegalEntityDto>(`/platform-service/v1/legal-entities/${id}`);
  return response.data;
};

export const createLegalEntity = async (
  data: CreateLegalEntityPayload,
): Promise<LegalEntityDto> => {
  const response = await api.post<LegalEntityDto>('/platform-service/v1/legal-entities', data, { successToast: true });
  return response.data;
};

export const updateLegalEntity = async (
  id: string,
  data: UpdateLegalEntityPayload,
): Promise<LegalEntityDto> => {
  const response = await api.put<LegalEntityDto>(
    `/platform-service/v1/legal-entities/${id}`,
    data,
    { successToast: true },
  );
  return response.data;
};

export const deleteLegalEntity = async (id: string): Promise<void> => {
  await api.delete(`/platform-service/v1/legal-entities/${id}`, { successToast: true });
};
